function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.253 1.413L7.84 0 .48 7.359 0 7.817l.011.012-.001.001 1.413 1.412.002-.002 6.453 6.445 1.364-1.365-6.451-6.446z",
  clipRule: "evenodd"
});

var SvgFeatArr = function SvgFeatArr(props) {
  return React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB3aWR0aD0iOS4zMzNweCIgaGVpZ2h0PSIxNS45MTdweCIgdmlld0JveD0iMCAwIDkuMzMzIDE1LjkxNyIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgOS4zMzMgMTUuOTE3IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxnPg0KCQk8cG9seWdvbiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgcG9pbnRzPSI5LjI1MywxLjQxMyA3Ljg0LDAgMC40OCw3LjM1OSAwLDcuODE3IDAuMDExLDcuODI5IDAuMDEsNy44MyANCgkJCTEuNDIzLDkuMjQyIDEuNDI1LDkuMjQgNy44NzgsMTUuNjg1IDkuMjQyLDE0LjMyIDIuNzkxLDcuODc0IAkJIi8+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo=";
export { SvgFeatArr as ReactComponent };